import { useRoute } from '~/infrastructure';
import { storeToRefs } from 'pinia';
import { userService, useUserStore } from '~/domains/user';

interface UseInitLanguageReturn {
  initLanguage: () => Promise<void>;
}

export default function useInitLanguage(): UseInitLanguageReturn {
  const route = useRoute();
  const { selectedLanguage, user } = storeToRefs(useUserStore());
  const { setUser } = useUserStore();

  const initLanguage = async (): Promise<void> => {
    const queryLang = route.query.lang as string | undefined;
    const queryLowerCase = queryLang?.toLowerCase();

    if (
      typeof queryLowerCase === 'string' &&
      selectedLanguage.value !== queryLowerCase
    ) {
      try {
        const isSupported = user.value?.languages.some(
          (l) => l.language === queryLowerCase,
        );

        if (isSupported === true) {
          const changedUserInfo = await userService.changeUserInfo({
            language: queryLowerCase,
          });

          if (changedUserInfo != null) {
            setUser(changedUserInfo);
          }
        }
      } catch (e) {
        console.error(e);
      }
    }
  };

  return {
    initLanguage,
  };
}
